import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {ENDPOINT_TERRITOIRES} from "../constants/endpoints";

let store = {
  debug: true,
  state: {
    territoires: []
  },

  getAll() {
    if (this.state.territoires.length === 0) {
      return axios.get(ENDPOINT_TERRITOIRES)
          .then(response => {
            this.state.territoires = response.data;
            return this.state.territoires;
          })
          .catch(error => AlertStore.pushError(error.response.data.message));
    } else {
      return new Promise(resolve => {
        resolve(this.state.territoires);
      });
    }
  }
};

export default store;
